import { Capacitor } from '@capacitor/core';

// GoogleSignIn requires this to match the reversed client ID URL scheme in the iOS Info.plist files.
const GOOGLE_IOS_CLIENT_ID = '557194579793-kp7l6fq8tpbjovovn8tjjqavqnqeeh2l.apps.googleusercontent.com';

export const NATIVE_LOGIN_CANCELLED_CODE = 'USER_CANCELLED';

// The plugin entry module runs web OAuth redirect code when it loads. A dynamic import keeps it out of the web bundle.
async function loadSocialLogin() {
    const { SocialLogin } = await import('@capgo/capacitor-social-login');
    return SocialLogin;
}

async function initializeGoogle(webClientId: string) {
    const SocialLogin = await loadSocialLogin();
    await SocialLogin.initialize({ google: { webClientId, iOSClientId: GOOGLE_IOS_CLIENT_ID } });
    return SocialLogin;
}

export async function getNativeProviderData(provider: string, googleWebClientId: string) {
    if (provider === 'google_oauth2') {
        const SocialLogin = await initializeGoogle(googleWebClientId);

        // Without forcePrompt, iOS signs in again as the last Google account and shows no account chooser.
        const { result } = await SocialLogin.login({ provider: 'google', options: { forcePrompt: true } });
        return result;
    }

    // Android has no native Sign in with Apple, so the app does not offer Apple there.
    if (provider === 'apple_quantic' && Capacitor.getPlatform() === 'ios') {
        const SocialLogin = await loadSocialLogin();
        await SocialLogin.initialize({ apple: {} });
        const { result } = await SocialLogin.login({ provider: 'apple', options: { scopes: ['email', 'name'] } });
        const { user, email, givenName, familyName } = result.profile;

        // Auth::NativeOauthExchangesController#apple_quantic reads the shape of the old Cordova plugin's response.
        return { user, email, fullName: { givenName, familyName }, identityToken: result.idToken };
    }

    throw new Error('Unsupported native provider');
}

export async function signOutOfNativeGoogle(webClientId: string) {
    const SocialLogin = await initializeGoogle(webClientId);
    await SocialLogin.logout({ provider: 'google' });
}
